import React, { FC, ReactNode } from 'react';

type Props = {
  data: { label: string; value: string | undefined | null | number; tag?: ReactNode };
  className: string;
  metaText?: string;
};
const BrandDetailsCard: FC<Props> = ({ data, className, metaText }) => {
  return (
    <div
      className={`flex flex-row items-center border border-1 rounded-[10px] gap-[30px] border-[#EDEDEE] px-[24px] py-4 ${className}`}>
      <p className='min-w-[150px] font-medium text-[#858585] '>{data.label}</p>
      <div className='flex gap-3'>
        <p className='text-base font-medium capitalize'>{data.value}</p>
        {data?.tag}
        {metaText && (
          <div>
            <p className='text-[#E60A2B] bg-[#FEF0F2] text-sm  rounded-full py-1 px-3 '>
              {metaText}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandDetailsCard;
